import {CtModelRouteData} from "@ctsolution/ct-framework";

export const TaskTypeRouteData = (): CtModelRouteData => CtModelRouteData
  .create()
  .setController("tasktype");